package com.essntl.features.country.ui.allcountries

import com.essntl.features.country.domain.model.CountryModel

sealed interface AllCountriesEvent {
    data object GetAllCountries : AllCountriesEvent
    data class AddCountry(val c: CountryModel) : AllCountriesEvent
    data class EditCountry(val c: CountryModel) : AllCountriesEvent
    data class DeleteCountry(val c: CountryModel) : AllCountriesEvent
}